import {httpGetProjectOtherPathologies} from '@/features/projects/http/projects.http'
import {ProjectPathology} from '@/features/projects/types'
import {QUERY_KEYS} from '@/queryClient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'

interface UseGetProjectOtherPathologiesOptions {
    urlParams: {
        projectId: string
    }
    options?: Omit<UseQueryOptions<Omit<ProjectPathology, 'startedAt'>[]>, 'queryKey' | 'queryFn'>
}

export const useGetProjectOtherPathologies = ({urlParams, options}: UseGetProjectOtherPathologiesOptions) => {
    return useQuery({
        queryKey: [QUERY_KEYS.PROJECT_OTHER_PATHOLOGIES, urlParams.projectId],
        queryFn: () => httpGetProjectOtherPathologies({urlParams}),
        ...options
    })
}
